module.exports = __webpack_public_path__ + "img/btn-gr-3.b47ef119.png";